import PetsDeliLogoIcon from 'assets/icons/pets-deli-logo-new.svg';
import React from 'react';

interface Props {
  renderTitle?: React.ReactElement;
  title?: string;
  onLogoClick: () => void;
}

const FunnelHeader: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  renderTitle,
  title,
  onLogoClick,
}) => {
  return (
    <div className="z-mobile-navigation fixed top-0 left-0 w-screen">
      <div className="bg-primary-main text-text-dark-bg-contrast-primary">
        <div className="relative mx-auto flex h-13.5 items-center justify-center px-6 md:px-8 lg:container lg:justify-start">
          <button className="focus-default" data-testid="funnel-header-logo" onClick={onLogoClick}>
            <PetsDeliLogoIcon className="h-6 w-32 lg:h-6.5" />
          </button>

          {(title || renderTitle) && (
            <div className="absolute left-1/2 hidden -translate-x-1/2 lg:block">
              {title && <div className="text-lg font-black">{title}</div>}
              {renderTitle}
            </div>
          )}
        </div>
      </div>

      {children}
    </div>
  );
};

export default FunnelHeader;
